module.exports = __webpack_public_path__ + "static/media/dartsafearea-png.4a9fb7ef.png";